import React, { forwardRef, useEffect, useState } from 'react';
import Button, { ButtonProps } from 'product_modules/components/Button/Button';

export interface ButtonWithLoadingStateProps extends Omit<ButtonProps, 'isLoading' | 'onClick'> {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<unknown>;
}

const ButtonWithLoadingState = forwardRef<HTMLButtonElement, ButtonWithLoadingStateProps>((props, ref) => {
  const { onClick } = props;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      setIsLoading(false); 
    };
  }, []);
  
  const handleClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setIsLoading(true);
    try {
      await onClick(e);
    } finally {
      setIsLoading(false);
    }
  };

  return <Button ref={ref} {...props} isLoading={isLoading} onClick={handleClick} />;
});

export default ButtonWithLoadingState;
